import React from "react";
import * as S from "./styles";
import { ITransactionItem } from "../../utils/services/modules/transactions";
import { formatTime } from "../../utils/formatDatas";

interface ITransactionItemProps {
  transaction: ITransactionItem;
  index: number; // posição na lista, usada na animação de entrada
  onClick?: (transaction: ITransactionItem) => void;
}

const serializerNumber = (value: number) =>
  value.toLocaleString("pt-BR", { maximumFractionDigits: 0 });

const TransactionItem: React.FC<ITransactionItemProps> = ({
  transaction,
  index,
  onClick,
}) => {
  const sent = transaction.direction === "sent";

  return (
    <S.Card
      $index={index}
      $clickable={!!onClick}
      onClick={onClick ? () => onClick(transaction) : undefined}
      role={onClick ? "button" : undefined}
    >
      <S.IconCircle $sent={sent}>
        {sent ? <S.SentIcon /> : <S.ReceivedIcon />}
      </S.IconCircle>

      <S.InfoGroup>
        <S.Name>{transaction.name}</S.Name>
        <S.SubInfo>
          {sent ? "Enviado para" : "Recebido de"} · ID {transaction.code}
        </S.SubInfo>
      </S.InfoGroup>

      <S.ValueGroup>
        <S.Value $sent={sent}>
          {sent ? "-" : "+"} {serializerNumber(transaction.amount)}
        </S.Value>
        <S.Time>{formatTime(transaction.date)}</S.Time>
      </S.ValueGroup>
    </S.Card>
  );
};

export default TransactionItem;
